import { Locale } from 'modules/domains/template';
import { NegativeFillDiamond } from 'ui/icons';
import { colors } from 'ui/theme';

import { LocaleLabel } from '../../../LocaleLabel/LocaleLabel';
import {
  DefaultLocaleSubLabel,
  LocaleLabelContainer,
  StyledErrorLocaleContainer,
} from '../../LocaleSwitcher.styled';

type LocaleLocaleProps = {
  isDisabled?: boolean;
  localeHasError: boolean;
  projectLocale: Locale;
  isAvailableLocale?: boolean;
  defaultLocaleSubLabel?: string;
};

export const LocaleSwitcherLabel = ({
  isDisabled,
  localeHasError,
  projectLocale,
  isAvailableLocale,
  defaultLocaleSubLabel,
}: LocaleLocaleProps) => (
  <LocaleLabelContainer $hasError={localeHasError}>
    <LocaleLabel
      locale={projectLocale}
      isAvailableLocale={isAvailableLocale}
      isDisabled={isDisabled}
    />

    {localeHasError && (
      <StyledErrorLocaleContainer data-test={`locale-error-${projectLocale.tag}`}>
        <NegativeFillDiamond color={colors.red100} width={14} height={14} />
      </StyledErrorLocaleContainer>
    )}

    {defaultLocaleSubLabel && (
      <DefaultLocaleSubLabel>{defaultLocaleSubLabel}</DefaultLocaleSubLabel>
    )}
  </LocaleLabelContainer>
);
